import { render, staticRenderFns } from "./DownloadItemButton.vue?vue&type=template&id=1acc84b6"
import script from "./DownloadItemButton.vue?vue&type=script&lang=js"
export * from "./DownloadItemButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports